import { IconButton } from '@nexelem/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { PropsWithChildren, ReactNode } from 'react';
import { cn } from '@nexelem/utils';

type DrawerHeaderProps = {
  onClose?: () => void;
  title?: ReactNode;
  className?: string;
  tabs?: ReactNode;
};

export const DrawerHeader = ({ onClose, title, children, className, tabs }: PropsWithChildren<DrawerHeaderProps>) => (
  <>
    <div className={cn('shrink-0 py-4 pr-2 pl-6', !tabs && 'border-b border-border-primary', className)}>
      <div className="flex items-center justify-between">
        {title}
        {onClose && (
          <IconButton className="shrink-0" Icon={<FontAwesomeIcon icon={faXmark} />} size="small" onClick={onClose} />
        )}
      </div>
      {children}
    </div>
    {tabs && <div>{tabs}</div>}
  </>
);
